import React, {Component} from "react";
import {Alert, Badge} from "react-bootstrap";
import {AppContext} from "../../AppContext";
import axios from "axios";

/**
 * Adnotacje z przypomnień handlowych zapisanych przy danym protokole serwisowym.
 * Materiał wewnętrzny - świadomie tylko w aplikacji, nigdy w PDF protokołu.
 * Nic nie renderuje, jeśli przy protokole nie ma odpowiedzi.
 */
class ServiceReminderAnnotations extends Component {

    static contextType = AppContext;

    state = {
        answers: []
    }

    componentDidMount() {
        this.loadAnswers();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.serviceId !== this.props.serviceId) {
            this.loadAnswers();
        }
    }

    loadAnswers = () => {
        if (!this.props.serviceId || this.props.serviceId === 0) {
            this.setState({answers: []});
            return;
        }
        axios.get(`${this.context.hostname}/api/reminder/byService/${this.props.serviceId}`, {
            headers: {"X-Requested-With": "XMLHttpRequest", "Content-Type": "application/json"},
            withCredentials: true
        }).then(res => {
            this.setState({answers: res.data});
        }).catch((error) => {
            //Brak adnotacji nie może zepsuć widoku protokołu
            console.log({error});
            this.setState({answers: []});
        });
    }

    render() {
        if (this.state.answers.length === 0) {
            return false;
        }
        return (
            <Alert variant='light' style={{border: '1px solid #D12323', padding: '8px 10px', fontSize: 13}}>
                <div style={{color: '#D12323', fontWeight: 'bold', marginBottom: 5}}>
                    Przypomnienia handlowe (materiał wewnętrzny — nie trafia do protokołu PDF)
                </div>
                {this.state.answers.map(answer =>
                    <div key={answer.id} style={{marginBottom: 3}}>
                        {answer.date} — {answer.question}{' '}
                        {answer.answer === 'TAK' && answer.verified === false
                            ? <span><Badge bg="danger">TAK — niepotwierdzone</Badge> <span style={{fontSize: 11}}>{answer.verificationNote}</span></span>
                            : (answer.answer === 'TAK' || answer.resolved
                                ? <Badge bg="success">TAK</Badge>
                                : <Badge bg="danger">NIE</Badge>)}
                        {answer.answer !== 'TAK' && answer.resolved &&
                            <span style={{fontSize: 11}}>
                                {' '}(początkowo NIE{answer.reason ? `: ${answer.reason}` : ''} → wykonano {answer.resolvedAt}
                                {answer.resolvedByName ? `, ${answer.resolvedByName}` : ''})
                            </span>}
                        {answer.answer !== 'TAK' && !answer.resolved &&
                            <span> — {answer.reason}{' '}
                                {/* "do zrobienia" tylko gdy po tej odpowiedzi nie ma nowszego potwierdzenia */}
                                {answer.requiresAction &&
                                    <span style={{fontSize: 11, color: '#D12323'}}>do zrobienia</span>}
                            </span>}
                        {answer.authorName ? <span style={{fontStyle: 'italic'}}> ({answer.authorName})</span> : false}
                    </div>
                )}
            </Alert>
        );
    }
}

export default ServiceReminderAnnotations;
